export enum ServiceDataFields {
  PregnancyInformation = 'PregnancyInformation',
  AdditionalPatientInformation = 'AdditionalPatientInformation',
  Height = 'Height',
  Weight = 'Weight',
  DocumentNumber = 'DocumentNumber',
  DueDate = 'DueDate',
  PregnancyType = 'PregnancyType',
  PatientHistoryInformation = 'PatientHistoryInformation',
  HistoryOfCancer = 'HistoryOfCancer',
  HumanSerumAlbuminTherapy = 'HumanSerumAlbuminTherapy',
  CellularImmunotherapy = 'CellularImmunotherapy',
  StemCellTherapy = 'StemCellTherapy',
  TransplantSurgery = 'TransplantSurgery',
  BloodTransfusion = 'BloodTransfusion',
  RhdStatus = 'RhdStatus',
  GenderInformation = 'GenderInformation',
  IncidentalFindings = 'IncidentalFindings',
  MonogenicIncidentalFindings = 'MonogenicIncidentalFindings',
  Ivf = 'Ivf',
  VanishingTwinSyndrome = 'VanishingTwinSyndrome',
  HeparinTherapy = 'HeparinTherapy',
  DateOfUltrasound = 'DateOfUltrasound',
  PriorScreeningTest = 'PriorScreeningTest',
  ParaAndGravida = 'ParaAndGravida',
  PreviousPregnanciesGeneticCondition = 'PreviousPregnanciesGeneticCondition',
  FamilyHistoryOfGeneticDiseases = 'FamilyHistoryOfGeneticDiseases',
  CarrierOfGeneticCondition = 'CarrierOfGeneticCondition',
  MonogenicDisorderCarrier = 'MonogenicDisorderCarrier',
  ChromosomalAbnormalityCarrier = 'ChromosomalAbnormalityCarrier',
  FamilyHistoryOfCysticFibrosis = 'FamilyHistoryOfCysticFibrosis',
  DiseaseHistory = 'DiseaseHistory',
  FamilyCancerHistory = 'FamilyCancerHistory',
  KnownFamilyMutations = 'KnownFamilyMutations',
  PatientGender = 'PatientGender',
  Ethnicity = 'Ethnicity',
  CardiovascularConditions = 'CardiovascularConditions',
  CardiovascularConditionsInFamilyHistory = 'CardiovascularConditionsInFamilyHistory',
  CurrentlyDiagnosedWithCancer = 'CurrentlyDiagnosedWithCancer',
  CancerSurvivor = 'CancerSurvivor',
  BoneMarrowTransplant = 'BoneMarrowTransplant',
  SolidOrganTransplant = 'SolidOrganTransplant',
  CancerSuspicion = 'CancerSuspicion',
  PregnancyStatus = 'PregnancyStatus',
  AllegedFather = 'AllegedFather',
  AdditionalParticipants = 'AdditionalParticipants',
  Relationship = 'Relationship',
  ParentingTestType = 'ParentingTestType',
  FraternityInformation = 'FraternityInformation',
  RecentPregnancy = 'RecentPregnancy',
  ParticipantsStemCellTherapy = 'ParticipantsStemCellTherapy',
  ParticipantsBloodTransfusion = 'ParticipantsBloodTransfusion',
  // Not part of any field set, added for products with requirePatientAddress
  PatientAddress = 'PatientAddress',
}
